import USER from '@/constants/user';

const storageUserId = localStorage.getItem(USER.STORAGE_USER_ID);
const storageTrial = localStorage.getItem(USER.STORAGE_COMPANY_TRIAL);
const storageAnalysisCount = localStorage.getItem(USER.STORAGE_COMPANY_ANALYSIS_COUNT);
const storageFarmsCount = localStorage.getItem(USER.STORAGE_COMPANY_FARMS_COUNT);
const storageAnalitica = localStorage.getItem(USER.STORAGE_COMPANY_ANALITICA);
const storageSentinela = localStorage.getItem(USER.STORAGE_COMPANY_SENTINELA);
const storageCompanyId = localStorage.getItem(USER.STORAGE_COMPANY_ID);
const storageCompanyClientId = localStorage.getItem(USER.STORAGE_COMPANY_CLIENT_ID);
const authorities = localStorage.getItem(USER.STORAGE_AUTHORITIES);

export default {
  username: localStorage.getItem(USER.STORAGE_USERNAME) || '',
  userId: storageUserId ? JSON.parse(storageUserId) : null,
  name: localStorage.getItem(USER.STORAGE_NAME) || '',
  email: localStorage.getItem(USER.STORAGE_EMAIL) || '',
  status: localStorage.getItem(USER.STORAGE_USERNAME) ? 'success' : '',
  companyName: localStorage.getItem(USER.STORAGE_COMPANY_NAME) || '',
  companyDoc: localStorage.getItem(USER.STORAGE_COMPANY_DOC) || '',
  companyZipCode: localStorage.getItem(USER.STORAGE_COMPANY_ZIPCODE) || '',
  companyAddress: localStorage.getItem(USER.STORAGE_COMPANY_ADDRESS) || '',
  companyPhone: localStorage.getItem(USER.STORAGE_COMPANY_PHONE) || '',
  companyTrial: storageTrial ? JSON.parse(storageTrial) : false,
  companyAnalysisCount: storageAnalysisCount ? parseInt(storageAnalysisCount, 10) : 0,
  companyFarmsCount: storageFarmsCount ? parseInt(storageFarmsCount, 10) : 0,
  companyAnalitica: storageAnalitica ? JSON.parse(storageAnalitica) : false,
  companySentinela: storageSentinela ? JSON.parse(storageSentinela) : false,
  companyId: storageCompanyId ? JSON.parse(storageCompanyId) : '',
  companyClientId: storageCompanyClientId ? JSON.parse(storageCompanyClientId): null,
  authorities: authorities ? JSON.parse(authorities) : [],
};
